import React from 'react';
import { Box, ModalBody, ModalCloseButton, ModalHeader, Text, VStack } from '@chakra-ui/react';

const RawDataViewer = ({ title, data }) => {
  return (
    <>
      <ModalHeader textAlign="center" py={0}>
        <Text size="3xl">{title}</Text>
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Box>
          <VStack align="start" w="100%">
            <ul>
              {Array.isArray(data) && data.length > 0 ? (
                data.map((item, index) => (
                  <li key={index}>
                    <Text color="brand.200">{item}</Text>
                  </li>
                ))
              ) : (
                <li>
                  <Text color="gray.500">No items found.</Text>
                </li>
              )}
            </ul>
          </VStack>
        </Box>
      </ModalBody>
    </>
  );
};

export default RawDataViewer;
